export default __webpack_public_path__ + "static/media/advice-working-on.aefdee8c.svg";